import { render, staticRenderFns } from "./About.vue?vue&type=template&id=5c3f3b2d&scoped=true"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=5c3f3b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f3b2d",
  null
  
)

export default component.exports